export const build = {"tag":"c65ac5f3f61de6ba6b23e80db8ee97dc01854ff5","hash":"c65ac5f3","time":"260507.0850"}